import { CheckboxStateEnum } from "../../../../../shared/enums/CheckboxSelectionType";
import { AppUtils } from '../../../../../shared/utils/index';

/**
 * Model class for the DamageForm
 */
export class DamageFormModel {
	private schadenTyp: string;
	private betroffenePerson: string;
	private betroffenePersonVorname: string;
	private betroffenePersonNachname: string;
	private betroffenePersonGeburtsdatum: string;
	private betroffenePersonGemeldet: CheckboxStateEnum;
	private eigeneAngabenBeschreibung: string;
	private schadenStartDatum: string;
	private schadenLand: string;
	private schadenLandName: string;
	private abreiseDatum: string;
	private behandlung: CheckboxStateEnum;

	public get SchadenTyp(): string {
		return this.schadenTyp;
	}
	public set SchadenTyp(value: string) {
		this.schadenTyp = value;
	}

	public get BetroffenePerson(): string {
		return this.betroffenePerson;
	}
	public set BetroffenePerson(value: string) {
		this.betroffenePerson = value;
	}

	public get BetroffenePersonVorname(): string {
		return this.betroffenePersonVorname;
	}
	public set BetroffenePersonVorname(value: string) {
		this.betroffenePersonVorname = value;
	}

	public get BetroffenePersonNachname(): string {
		return this.betroffenePersonNachname;
	}
	public set BetroffenePersonNachname(value: string) {
		this.betroffenePersonNachname = value;
	}

	public get BetroffenePersonGeburtsdatum(): string {
		return this.betroffenePersonGeburtsdatum;
	}
	public set BetroffenePersonGeburtsdatum(value: string) {
		this.betroffenePersonGeburtsdatum = value;
	}

	public get BetroffenePersonGemeldet(): CheckboxStateEnum {
		return this.betroffenePersonGemeldet;
	}
	public set BetroffenePersonGemeldet(value: CheckboxStateEnum) {
		this.betroffenePersonGemeldet = value;
	}

	public get EigeneAngabenBeschreibung(): string {
		return this.eigeneAngabenBeschreibung;
	}
	public set EigeneAngabenBeschreibung(value: string) {
		this.eigeneAngabenBeschreibung = value;
	}

	public get SchadenStartDatum(): string {
		return this.schadenStartDatum;
	}
	public set SchadenStartDatum(value: string) {
		this.schadenStartDatum = value;
	}

	public get SchadenLand(): string {
		return this.schadenLand;
	}
	public set SchadenLand(value: string) {
		this.schadenLand = value;
	}

	public get SchadenLandName(): string {
		return this.schadenLandName;
	}
	public set SchadenLandName(value: string) {
		this.schadenLandName = value;
	}

	public get AbreiseDatum(): string {
		return this.abreiseDatum;
	}
	public set AbreiseDatum(value: string) {
		this.abreiseDatum = value;
	}

	public get Behandlung(): CheckboxStateEnum {
		return this.behandlung;
	}
	public set Behandlung(value: CheckboxStateEnum) {
		this.behandlung = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): DamageFormModel {
		return AppUtils.Helper.createFromMap(dataObject, DamageFormModel);
	}
}